export const SvgPlay = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20viewBox%3D"0%200%2026.19%2030"%3E%3Cpath%20d%3D"M0%200v30l26.19-15L0%200z"%2F%3E%3C%2Fsvg%3E';
export default SvgPlay;
